<div class="page-container">
  <header class="page-header" aria-labelledby="page-title">
    <div class="header-titles">
      <ng-content select="[psPageTitle]"></ng-content>
      <ng-content select="[psPageSubtitle]"></ng-content>
    </div>
  </header>

  <main class="page-content">
    <ng-content />
  </main>
</div>
